import $ from 'jquery';
import BookingValidation from '../booking-validation/booking-validation';
import * as BookingWizard from '../booking-wizard';
import { TripAddBundleWidget } from '../../tripadd/bundle-widget/tripadd-bundle-widget';
import { initializePaymentSummary, updateBookNowAmount } from '../payment-summary/payment-summary';


// tslint:disable-next-line: no-unused-expression
const bookingValidation = new BookingValidation(window);
window['TripAddBundleWidget'] = TripAddBundleWidget;
export const updateInsurance = () => {
    const token = $('input[name="__RequestVerificationToken"]', '.active-details-panel').val()
    const bookingId = $('input[name="BookingId"]').val()
    const ancillaries: any[] = []
    $('.travel-insurance input[type="checkbox"]').each((idx, el) => {
        const provider = el.getAttribute("data-provider");
        let isChecked = $(el).prop("checked");
        var checkedRadioId = isChecked ? $(`input[type='radio'][name='Ancillaries[${idx}].BaggagePlanId']:checked`).val() : undefined;

        ancillaries.push({
            id: el.getAttribute("id"),
            selected: isChecked,
            baggagePlanId: checkedRadioId,
            provider: provider,
        })
    })

    $('#wait-total-price').addClass('-with-wait-indicator');
    $('#reviewAndPayButton').prop("disabled", true);
    $.ajax({
        url: "/FlightBooking/ExtraItems",
        method: "POST",
        dataType: "html",
        data: {
            __RequestVerificationToken: token,
            bookingId,
            ancillaries
        },
        success: function (result) {
            $('#paymentSummaryRightPanel').html(result);
            updateBookNowAmount();
            initializePaymentSummary()
        },
        error: function (request, status, error) {
            console.error(request.responseText);
        },
        complete: function () {
            $('#wait-total-price').removeClass('-with-wait-indicator');
            $('#reviewAndPayButton').prop("disabled", false);
        }
    })
}

export let initBookingInsurance = () => {
    BookingWizard.InitializeFareConditionAdvice();
    BookingWizard.InitializePaymentInstallments();
    BookingWizard.InitializeMagnificPopup();
    BookingWizard.StickySummary();
    BookingWizard.InitializeFlightDetails();
    BookingWizard.ScrollToActionablePosition();

    $('body').on('click', '.js-wizard-next', () => {
        $('#reviewAndPayButton').prop('disabled', true);

        //If there is any validation error, scroll to the error and enable the reviewAndPayButton
        BookingWizard.ScrollToError(() => $('#reviewAndPayButton').prop('disabled', false));
    });

    $('.js-conditional-required').each((index, container) => {
        const checker = $(container).find('.js-conditional-required-checker').first()[0] as HTMLInputElement;
        const checkedElements = $(container).find('.js-conditional-required-checked').toArray() as HTMLInputElement[];
        bookingValidation.attachConditionalRequiredValidator(checker, checkedElements);
    });

    const selectInsurancePlan = (event: JQuery.ClickEvent) => {
        const bindingTarget = event.currentTarget;
        const clickedTarget = event.target;
        let provider = bindingTarget.getAttribute('data-provider');

        if ($(clickedTarget).hasClass('js-popup-trigger')) {
            return;
        }

        if (clickedTarget.tagName === "A") {
            if (provider == "BlueRibbonBags") {
                return;
            }

            event.stopPropagation();
            return;
        }

        event.preventDefault()

        if (!provider) {
            if (clickedTarget.classList.contains("js-get-travel-insurance")) {
                const id = clickedTarget.getAttribute("data-for");
                const label = document.querySelector(`.js-fake-label[data-for="${id}"]`) as HTMLLabelElement;
                const checkBox = document.querySelector(`input[id="${id}"]`) as HTMLInputElement;
                provider = label.getAttribute("data-provider");
                const keepSelected = provider == "BlueRibbonBags" && checkBox.checked ? true : false;
                updateAncillariesState(event, keepSelected);
                $(`.baggage-plans-container`).addClass('active');
                return;
            }

            event.stopPropagation();
            return;
        }

        updateAncillariesState(event);
    }

    $('.js-fake-label').on('click', (event: JQuery.ClickEvent) => {
        selectInsurancePlan(event);
    });

    $('.js-get-travel-insurance').on('click', (event: JQuery.ClickEvent) => {
        selectInsurancePlan(event);
        $.magnificPopup.close();
        return false;
    });

    $('.baggage-plan-detail').on('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        let plan = event.target;
        if (!event.target.classList.contains('baggage-plan-detail')) {
            plan = event.target.closest('.baggage-plan-detail') as HTMLElement;
        }
        const provider = $(plan).closest('[data-provider]').attr('data-provider');
        const type = $(plan).closest('[data-type]').attr('data-type');
        const idx = plan.getAttribute("data-plan-no");
        selectAncillaryOption(provider,type,idx);
        updateInsurance();
    });
};

const updateAncillariesState = (event: JQuery.ClickEvent, keepState?: boolean) => {
    const bindingTarget = event.currentTarget;
    const forAttributeValue = $(bindingTarget).data('for');
    const provider = bindingTarget.getAttribute("data-provider");
    const type = bindingTarget.getAttribute('data-type');
    const idx = bindingTarget.getAttribute("data-plan-no");
    keepState ??= false;

    $('.js-fake-label').removeClass('-checked');
    $(`.js-fake-label[data-for="${forAttributeValue}"]`).addClass('-checked');

    if (!keepState) {
        if ($(`input#${forAttributeValue}`).prop('checked') == true) {
            $(`input#${forAttributeValue}`).prop('checked', false);
        } else {
            $(`input#${forAttributeValue}`).prop('checked', true);
        }
    }

    if (provider == "BlueRibbonBags") {
        const checkBox = document.querySelector(`input[id="${forAttributeValue}"]`) as HTMLInputElement;
        if (checkBox.checked) {
            $(`.baggage-plans-container`).addClass('active');
        } else {
            $(`.baggage-plans-container`).removeClass('active');
            setTimeout(() => {
                selectAncillaryOption(provider,type,idx);
            }, 500);
        }
    }
    selectAncillaryOption(provider,type,idx);
    updateInsurance()
}

const selectAncillaryOption = (provider: string|undefined,type:string|undefined, idx: string | null) => {
    const planIdx = parseInt(idx ?? "0");
    // Find the parent with the matching provider
    const parent = document.querySelector(`.js-fake-label[data-provider="${provider}"][data-type="${type}"]`);
    if (!parent) {
        console.warn(`No parent found with data-provider="${provider}"`);
        return;
    }

    // Query `.baggage-plan-detail` within the found parent
    parent.querySelectorAll(`.baggage-plan-detail`).forEach((el, i) => {

        const inputElement = el.querySelector('input') as HTMLInputElement;

        if (inputElement && inputElement.type === 'hidden') {
            return; // Skip processing this element if the input is hidden
        }

        if (i == planIdx) {
            el.classList.add('active');
            (el.querySelector('input') as HTMLInputElement).checked = true;

            let coverPrice = el.getAttribute(`data-coverage-price`);
            let coverPriceElement = document.querySelector(`.bag-coverage-price`) as HTMLSpanElement;
            if (coverPriceElement && coverPrice) {
                coverPriceElement.innerHTML = coverPrice;
            }
        } else {
            el.classList.remove('active');
            (el.querySelector('input') as HTMLInputElement).checked = false;
        }
    });
}

 
$(initBookingInsurance);
